//
import { RTableHeaders } from '@/components/reusable_components/next'

//
export default new RTableHeaders( 'HrEmployeeIcQuoteHeaders',
    {
        text: '#',
        value: 'id',
        sortable: true,
        width: '5%',
    },
    {
        text: 'n° cuota',
        value: 'quote_number',
    },
    {
        text: 'monto',
        value: 'quote_amount',
        format: 'currency',
        width: '15%',
    },
    {
        text: 'periodo',
        value: 'period',
    },
    {
        text: 'fecha de descuento',
        value: 'discounted_at',
        align: 'right',
        format: 'date',
        width: '15%',
    },
)
